<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 15:31:22
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-08-24 14:12:58
 * @name: 主页公共头部
 * @Description: 主页公共头部
 * @FilePath: \preSaleNafterSaleBackstage\src\components\index\Head.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="indexHead">
    <div class="indexHeadContent">
      <img src="@/assets/image/logobig.png" />
      <div class="tabs">
        <template v-for="item of tabs">
          <div
            class="item"
            :class="{ actived: item.path === tabsActived }"
            :key="item.path"
            @click="tabsChange(item.path)"
            v-if="item.children.length > 0"
          >
            {{ item.label }}
            <div
              class="hasChild"
              id="position"
              v-if="item.path === tabsActived && item.children.length > 1"
            ></div>
          </div>
        </template>
      </div>
      <font class="logout" @click="logout">退出</font>
    </div>
    <div class="childTabs" v-if="childTabsShow">
      <div class="childTabsContent" :style="'left:' + offset">
        <div
          class="item"
          :class="{ actived: item.path === childTabsActived }"
          v-for="item of childTabs"
          :key="item.path"
          @click="childTabsChange(item.path)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import cookie from "@/storage/cookie";
import { confirmation, debounceation } from "@/utils/decorator";
import whiteList from "@/config/whiteList.config";

export default {
  name: "indexHead",
  data() {
    return {
      offset: "0px", //子导航内容dom偏移量
    };
  },
  computed: {
    tabs() {
      let tabs = this.$store.state.indexHead.tabs;
      let role_id = new cookie().getRoleId() ?? ""; //角色id,admin为超级管理员
      let auth_url = JSON.parse(new cookie().getAuthList() ?? "[]"); //权限列表
      if (role_id === "admin") {
        return tabs;
      } else {
        return tabs.map((x) => {
          x.children = x.children.filter(
            (y) => auth_url.includes(y.path) || whiteList.includes(y.path)
          );
          return x;
        });
      }
    },
    // 激活的导航栏tabs子导航
    childTabs() {
      return this.tabs.find((x) => x.path === this.tabsActived)?.children ?? [];
    },
    // 子导航是否显示
    childTabsShow() {
      return (
        this.childTabs.length > 1 &&
        this.childTabs.findIndex((x) => x.path === this.$route.path) > -1
      );
    },
    //激活的导航栏tabs
    tabsActived() {
      return this.$route.meta.activePath;
    },
    //激活的子导航
    childTabsActived() {
      return (
        this.childTabs.find((x) => x.path === this.$route.path)?.path ?? ""
      );
    },
  },
  watch: {
    $route: {
      handler(nv, ov) {
        this.$nextTick(() => {
          this.setOffset();
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 导航栏切换
     * @param {String} path 导航路径
     */
    @debounceation(300)
    tabsChange(path) {
      if (this.tabsActived === path) {
        return;
      }
      this.tabs.find((x) => x.path === path).children.length === 1 &&
        this.$router.replace(path);
      this.tabs.find((x) => x.path === path).children.length > 1 &&
        this.$router.replace(
          this.tabs.find((x) => x.path === path).children[0].path
        );
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 子导航栏切换
     * @param {String} path 子导航路径
     */
    @debounceation(300)
    childTabsChange(path) {
      if (this.$route.path === path) {
        return;
      }
      this.$router.replace(path);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 设置子导航栏内容dom偏移量
     */
    setOffset() {
      this.$el.querySelector(".actived")?.offsetLeft &&
        this.$el.querySelector("#position")?.offsetLeft &&
        (this.offset = `${
          this.$el.querySelector(".actived").offsetLeft +
          this.$el.querySelector("#position").offsetLeft +
          6
        }px`);
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击退出
     */
    @confirmation("确认退出登录?")
    logout() {
      new cookie().removeToken();
      location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.indexHead {
  width: 100%;
  .indexHeadContent {
    width: 100%;
    height: $Vars-head-height;
    background: $Vars-backgroud-head;
    box-sizing: border-box;
    padding: 0 30px;
    @extend .extend-flex-spacebetween;
    img {
      flex-shrink: 0;
    }
    .tabs {
      flex: 1;
      height: 100%;
      box-sizing: border-box;
      padding: 0 40px;
      @extend .extend-flex-start;
      .item {
        padding: 0 30px;
        height: 100%;
        background: $Vars-base-color-transparent;
        font-size: $Vars-font-miniTitle-size;
        color: $Vars-font-secondary-color;
        @extend .extend-flex-center;
        @extend .extend-clickElement;
        position: relative;
        &.actived {
          color: $Vars-base-color-white;
          background: $Vars-normal-color;
        }
        .hasChild {
          position: absolute;
          bottom: 0;
          margin: 0 auto;
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 6px solid white;
        }
      }
    }
    .logout {
      font-size: $Vars-font-miniTitle-size;
      color: $Vars-font-secondary-color;
      flex-shrink: 0;
      @extend .extend-clickElement;
    }
  }
  .childTabs {
    width: 100%;
    height: $Vars-childTabs-height;
    background: $Vars-base-color-white;
    box-sizing: border-box;
    border-bottom: 1px solid $Vars-background-light-gray;
    position: relative;
    .childTabsContent {
      position: absolute;
      transform: translateX(-50%);
      top: 0;
      height: $Vars-childTabs-height;
      @extend .extend-flex-center;
      .item {
        font-size: $Vars-font-content-size;
        color: $Vars-font-secondary-color;
        padding: 0 20px;
        @extend .extend-clickElement;
        &.actived {
          color: $Vars-normal-color;
        }
      }
    }
  }
}
</style>